// extracted by mini-css-extract-plugin
export default {"sec-btn1":"PaperFormat_sec-btn1__LsrBv","edit":"PaperFormat_edit__jEeEE","activate":"PaperFormat_activate__k2XPs","flex":"PaperFormat_flex__Lm5pF"};